module.exports = __webpack_public_path__ + "img/35-s.5142d3ff.png";